import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const InternationalOthersDetails = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'others',
  });

  return {
    title: t('title'),
    coverages:[
        {
            label: t('terrorism.label'),
            remarks:null, 
            insuredAmountData: [
                {
                    classId : 1,
                    amount: '-',
                    remark: null,
                    colspan: 1,
                },
                {
                    classId : 2,
                    amount: '-',
                    remark: null,
                    colspan: 1,
                },
                {
                    classId : 3,
                    amount: '-',
                    remark: null,
                    colspan: 1,
                }
            ],
        },
        {
          label: t('worldwide.label'),
          remarks:null, 
          insuredAmountData: [
              {
                  classId : 1,
                  amount: 'Included',
                  remark: null,
                  colspan: 1,
              },
              {
                  classId : 2,
                  amount: 'Included',
                  remark: null,
                  colspan: 1,
              },
              {
                  classId : 3,
                  amount: 'Included',
                  remark: null,
                  colspan: 1,
              }
          ],
      },
      {
        label: t('hotline.label'),
        remarks:null, 
        insuredAmountData: [
            {
                classId : 1,
                amount: 'Included',
                remark: null,
                colspan: 1,
            },
            {
                classId : 2,
                amount: 'Included',
                remark: null,
                colspan: 1,
            },
            {
                classId : 3,
                amount: 'Included',
                remark: null,
                colspan: 1,
            }
        ],
    },
    {
      label: t('free.label'),
      remarks:null, 
      insuredAmountData: [
          {
              classId : 1,
              amount: 'Included',
              remark: null,
              colspan: 1,
          },
          {
              classId : 2,
              amount: 'Included',
              remark: null,
              colspan: 1,
          },
          {
              classId : 3,
              amount: 'Included',
              remark: null,
              colspan: 1,
          }
      ],
  },
    ],
  };

};

export default InternationalOthersDetails;